export default __webpack_public_path__ + "static/media/warning--domestic-animals--g7.e8a76726.png";